import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useGlobalStore } from '../../../../store'
import forumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'
import { MuiSelect, MuiTextField, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import { convertStringToSelectArray } from '../../../../util'

const UserMarketResearchQuestionsLocal = ({ data, mode, onChange, expanded }) => {
  const { company } = useGlobalStore()

  const [formSectionData, setFormSectionData] = useState([])
  const [formSelectData, setFormSelectData] = useState({ question: [] })

  const onChangeHandler = (key, value) => {
    const obj = formSectionData
    obj[key] = value
    setFormSectionData(obj)
    onChange(obj)
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['UserLocalQuestions'],
      urlFunc: forumService.getOrganizationAggregationUserLocalQuestionFuncApi,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)

  /*
  const onload = async () => {
    const payload = { organizationId: company?.OrganizationId }
    const questionApi = await forumService.getOrganizationAggregationUserLocalQuestionFuncApi(payload)
    const data = []
    for (let i = 0; i < questionApi.length; i++) {
      if (i === 5) {
        data.push('')
      } else {
        const array = questionApi[i].length > 0 ? [{ label: ' ', value: ' ' }, ...convertStringToSelectArray(questionApi[i])] : [{ label: ' ', value: ' ' }]
        data.push(array)
      }
    }
    setFormSelectData(data)
  }
  */

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  useEffect(() => {
    const obj = {}
    for (let i = 1; i <= 12; i++) {
      obj[`LocalQuestion${i}`] = data[`LocalQuestion${i}`] || ''
    }
    setFormSectionData(obj)
  }, [formSelectData])

  // useEffect(() => {
  //   onload()
  // }, [])

  useEffect(() => {
    if (formSectionData) {
      onChange(formSectionData)
    }
  }, [formSectionData])

  const onSuccess1Func = (resp) => {
    const data = []
    for (let i = 0; i < resp.length; i++) {
      if (i === 5) {
        data.push('')
      } else {
        const array = resp[i].length > 0 ? [{ label: ' ', value: ' ' }, ...convertStringToSelectArray(resp[i])] : [{ label: ' ', value: ' ' }]
        data.push(array)
      }
    }
    setFormSelectData(data)
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  return (
    <AccordionWithArrow title='User Market Research Questions (LOCAL)' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      <MessageReactQuery
        isLoading={isLoading1}
        isSuccess={isSuccess1}
        data={data1}
        isError={isError1}
        error={error1}
      />
      <Grid container spacing={2}>
        {(Object.keys(formSectionData)).map((key, index) => {
          const i = index + 1
          if (!hasDataAndNotDisabled(formSectionData[key])) return false
          return (
            <Grid item xs={4} key={'userMarketResQuestionLocal__' + i}>
              { [6].includes(i)
                ? <MuiTextField
                    name={key}
                    // label={`Question ${i}`}
                    placeholder={`Question ${i}`}
                    onChange={(e) => onChangeHandler(key, e.target.value)}
                    variant='standard'
                    value={formSectionData[key] || ''}
                    disabled={mode}
                  />
                : <MuiSelect
                    data={formSelectData[i - 1]}
                    name={key}
                    // label={`Question ${i}`}
                    placeholder={`Question ${i}`}
                    onChange={(e) => onChangeHandler(key, e.target.value)}
                    variant='standard'
                    value={formSectionData[key] || ''}
                    disabled={mode}
                  />
              }
            </Grid>
          )
        })}
      </Grid>
    </AccordionWithArrow>
  )
}

UserMarketResearchQuestionsLocal.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default UserMarketResearchQuestionsLocal
